import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import LoaderSvg from 'images/v5/icons/loader.svg';
import styles from './InputNumber.module.scss';
function InputNumber({ name, value, size = 's', decimal, maxValue, suffix = null, noMaxWidth = false, onChange, onBlur, onMaxValueReached, onInvalidInput, loading = false, disabled = false, error, }) {
    const [inputValue, setInputValue] = useState(value);
    const [isFocused, setIsFocused] = useState(false);
    const inputClasses = classNames(styles.input, styles[size], {
        [styles.noMaxWidth]: noMaxWidth,
        [styles.error]: error,
    });
    const wrapClasses = classNames(styles.wrap, { [styles.block]: noMaxWidth });
    useEffect(() => {
        setInputValue(value);
    }, [value]);
    const handleChange = (e) => {
        let newValue = e.target.value;
        const numericValue = Number(newValue);
        if (decimal) {
            newValue = newValue.replace(',', '.');
        }
        if (!decimal) {
            newValue = newValue.replace('.', '');
        }
        const [integerPart, decimalPart] = newValue.split('.');
        if (decimal && decimalPart && decimalPart.length >= decimal) {
            newValue = `${integerPart}.${decimalPart.slice(0, decimal)}`;
        }
        if (!newValue.includes('.') && newValue.startsWith('0') && newValue.length > 1) {
            newValue = newValue.slice(1);
        }
        if (newValue === '') {
            setInputValue('0');
            onChange({ target: { name, value: 0 } });
            return;
        }
        if (!/^\d*\.?\d*$/.test(newValue)) {
            if (onInvalidInput) {
                onInvalidInput();
            }
            return;
        }
        if (maxValue && numericValue > maxValue) {
            newValue = String(maxValue);
            if (onMaxValueReached) {
                onMaxValueReached();
            }
        }
        setInputValue(newValue);
        const fakeEvent = {
            target: { name, value: Number(newValue) || 0 },
        };
        onChange(fakeEvent);
    };
    return (React.createElement("span", { className: wrapClasses },
        React.createElement("input", { name: name, className: inputClasses, type: "text", value: inputValue, onChange: handleChange, onFocus: () => setIsFocused(true), onBlur: () => {
                setIsFocused(false);
                onBlur === null || onBlur === void 0 ? void 0 : onBlur();
            }, disabled: disabled, autoComplete: "off" }),
        loading && isFocused && (React.createElement("span", { className: styles.loader },
            React.createElement(LoaderSvg, null))),
        suffix && React.createElement("span", { className: styles.suffix }, suffix)));
}
export default InputNumber;
